import { apiRequest } from './client'

export const alertsApi = {
    validateSchedule: () => apiRequest('/validate_schedule'),
}
